module.exports = __webpack_public_path__ + "img/image360.f77a6a6d.png";